export function getAmountInCent(amountDouble, mult) {
	let centAmount = 0;
	if (amountDouble != null) {
		centAmount = amountDouble * mult;
		let centString = centAmount + "";
		if (centString.indexOf(".") >= 0) {
			// c'e' stato errore nella conversione. Manca un centesimo nel risultato. Es: 64.49 -> 6448.99999 invece
			// di 6449 oppure 64.40 -> 6440.00000000001
			let decimals = centString.split(".")[1];
			centString = centString.split(".")[0]; // isolo la parte prima del punto
			centAmount = parseInt(centString, 10);
			
			if (decimals != null && decimals.startsWith("9")) {
				centAmount ++; // aggiungo 1				
			}
		}
	}
	
	return centAmount;
}
